export type AccessionLogPrefixSelection =
  | { prefixMode: "all"; prefixIds?: never }
  | { prefixMode: "none"; prefixIds?: never }
  | { prefixMode: "selected"; prefixIds: string[] };

export interface AccessionLogPrefixOption {
  id: string;
  code: string;
  isActive: boolean;
}

export function prefixSelectionLabel(
  value: AccessionLogPrefixSelection
): string {
  if (value.prefixMode === "all") return "All prefixes";
  if (value.prefixMode === "none") return "No prefixes selected";
  const count = value.prefixIds.length;
  return `${count} ${count === 1 ? "prefix" : "prefixes"} selected`;
}

export function prefixSelectionFromIds(
  ids: string[],
  optionIds: string[]
): AccessionLogPrefixSelection {
  if (!ids.length) return { prefixMode: "none" };
  if (
    ids.length === optionIds.length &&
    optionIds.every((id) => ids.includes(id))
  ) {
    return { prefixMode: "all" };
  }
  return { prefixMode: "selected", prefixIds: [...ids].sort() };
}
